import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'template', 'item', 'destroyField']

  connect() {
    this.index = this.itemTargets.length
  }

  addItem() {
    const template = this.templateTarget

    // Get template HTML and replace INDEX placeholder with actual index
    const templateHTML = template.innerHTML
    const newHTML = templateHTML.replace(/INDEX/g, this.index)

    // Create new element and append to container
    const wrapper = document.createElement('div')
    wrapper.innerHTML = newHTML
    const newItem = wrapper.firstElementChild

    this.containerTarget.appendChild(newItem)
    this.index++
  }

  removeItem(event) {
    const item = event.target.closest('[data-media-items-target="item"]')
    const destroyField = item.querySelector('[data-media-items-target="destroyField"]')

    if (destroyField) {
      // This is an existing record - mark for destruction
      destroyField.value = '1'
      item.style.display = 'none'
    } else {
      // This is a new record - remove from DOM
      item.remove()
    }
  }
}
